<template>
  <div class="c-video">
    <div class="container">
      <h3 class="c-video__title">{{ data.label }}</h3>
      <VueDPlayer
        v-if="!!data.link"
        ref="dplayer"
        :options="options"
        @play="getTimeFromVideo"
        @pause="getTimeFromVideo"
        @ended="getTimeFromVideo"
        @seeked="getTimeFromVideo"
        @timeupdate="getTimeFromVideo"
      ></VueDPlayer>
      <div class="c-video__btn-cnt" v-if="!canSend">
        <button class="btn btn-primary c-video__btn">
          <router-link class="c-video__link btn-primary btn" to="/dashboard">{{
            data.cta
          }}</router-link>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";

import { MissionService } from "@/common/services/api.service.js";
import { Mutations } from "@/store/global/global.types";

export default {
  name: "Video",
  components: {
    VueDPlayer
  },
  data() {
    return {
      data: {},
      options: {
        container: "",
        hotkey: false,
        video: {
          url: ""
        }
      },
      time: 0,
      canSend: true
    };
  },
  async mounted() {
    this.$store.commit(Mutations.SHOW_SPINNER);
    const res = await MissionService.getVideo(this.$route.params.videoId);
    this.$store.commit(Mutations.HIDE_SPINNER);
    this.data = res.data.data;
    this.options.video.url = this.data.link;
  },
  methods: {
    getTimeFromVideo() {
      this.time = Math.floor(
        this.$refs.dplayer.$el.querySelector("video").currentTime
      );
      if (this.data.min_seconds <= this.time && this.canSend) {
        this.canSend = false;
        MissionService.markVideoAsSeen(this.$route.params.videoId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-video {
  padding-bottom: 4rem;

  ::v-deep .dplayer-bar-wrap {
    pointer-events: none;

    .dplayer-played {
      pointer-events: all;
    }
  }
  ::v-deep .dplayer-setting {
    display: none;
  }
}
.c-video__title {
  text-align: center;
  margin: 50px 0;
}
.c-video__btn-cnt {
  margin: 50px 0;
  display: flex;
  justify-content: center;
}
.c-video__link {
  color: inherit;
  text-decoration: none;
  padding: 6px 50px;
  border-radius: 10px;
}
.c-video__btn {
}
</style>
